import { faQrcode } from '@fortawesome/pro-light-svg-icons';
import { Action, ButtonGroup, SimpleTooltip } from 'corso-admin-ui';
import { CrewMerchantUi, ShipmentMethod } from 'corso-types';
import ClipboardButton from '~/components/ClipboardButton';

type Shipment = NonNullable<CrewMerchantUi.ClaimShipment>;

const LOGO_URL = 'https://cdn.corso.com/img/hr-text-logo.png';

export default function ShipmentConsolidatedDropoff({
  shipment,
}: {
  shipment: Shipment;
}) {
  if (shipment.returnShipmentType !== ShipmentMethod.consolidatedDropoff) {
    return null;
  }

  const { consolidatedDropoffCode, returnShipmentPdfAssetUrl } = shipment;

  return (
    <div className="flex flex-col gap-4">
      <figure className="flex flex-col overflow-hidden rounded-lg border border-neutral-200">
        <figcaption className="flex items-center justify-center bg-[#FFD400] py-2">
          <img aria-hidden alt="Happy Returns" className="h-6" src={LOGO_URL} />
        </figcaption>
        <div className="flex flex-col items-center gap-6 p-6">
          <img
            alt={`Happy Returns QR code ${consolidatedDropoffCode}`}
            className="w-40"
            src={returnShipmentPdfAssetUrl}
          />
          <p className="text-sm tracking-widest">{consolidatedDropoffCode}</p>
        </div>
      </figure>

      <ButtonGroup horizontal>
        {/* the group stretches its direct children, and a tooltip trigger can't wrap a button */}
        <div className="text-center">
          <SimpleTooltip content="Copy Confirmation Code">
            <ClipboardButton
              onClick={() => consolidatedDropoffCode}
              accessibilityLabel="Copy Confirmation Code"
            />
          </SimpleTooltip>
        </div>

        <SimpleTooltip content="Download QR Code">
          <Action
            to={returnShipmentPdfAssetUrl}
            icon={faQrcode}
            accessibilityLabel="Download QR Code"
            download
          />
        </SimpleTooltip>
      </ButtonGroup>
    </div>
  );
}
